import type { PropTypes } from './ProfileSummaryItemWithEffectiveValue.types';
import type { ReactElement } from 'react';

import { Card, Flex, Separator, Skeleton, Text } from '@rango-dev/whale';
import React from 'react';

import { HoverCard } from '../HoverCard';

const TOTAL_VALUE_SKELETON_WIDTH = '178px';
const TOTAL_VALUE_SKELETON_HEIGHT = '36px';
const EFFECTIVE_VALUE_SKELETON_WIDTH = '70px';
const EFFECTIVE_VALUE_SKELETON_HEIGHT = '24px';
const HOVER_CARD_ICON_SIZE = 16;

export function ProfileSummaryItemWithEffectiveValue(props: PropTypes): ReactElement {
  return (
    <Card variant="surface" size="3">
      <Flex direction="column" gap="4">
        <Flex direction="column" align="center" gap="2">
          {props.icon}
          <Flex align="center" gap="2">
            <Text size="2" color="gray">
              {props.total.title}
            </Text>
            <HoverCard description={props.total.description} iconSize={HOVER_CARD_ICON_SIZE} />
          </Flex>
          {props.loading ? (
            <Skeleton width={TOTAL_VALUE_SKELETON_WIDTH} height={TOTAL_VALUE_SKELETON_HEIGHT} />
          ) : (
            <Text size="7" weight="bold">
              {props.total.value}
            </Text>
          )}
        </Flex>
        <Separator size="4" />
        <Flex
          direction={{ initial: 'column', xs: 'row' }}
          justify={{ initial: 'center', xs: 'between' }}
          align="center"
          gap="2">
          <Flex align="center" gap="2">
            <Text size="2" color="gray">
              {props.effective.title}
            </Text>
            <HoverCard description={props.effective.description} iconSize={HOVER_CARD_ICON_SIZE} />
          </Flex>
          {props.loading ? (
            <Skeleton
              width={EFFECTIVE_VALUE_SKELETON_WIDTH}
              height={EFFECTIVE_VALUE_SKELETON_HEIGHT}
            />
          ) : (
            <Text size="5" weight="bold">
              {props.effective.value}
            </Text>
          )}
        </Flex>
      </Flex>
    </Card>
  );
}
